/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';
import { call, put, takeEvery } from 'redux-saga/effects';

import { getAuthStatus as getAuthStatusApi } from '../../api/session';
import { fetchUserSuccess, fetchUserError } from './actions';
import * as types from './actionTypes';

/**
 * Saga generator that fetches the current user from the api
 * and then dispatches actions to add it to the store.
 */
export function* fetchUser() {
  try {
    const response = yield call(getAuthStatusApi);
    const user = _.pick(response.data, [
      'username',
      'email',
      'name',
      'iamId',
      'csrfToken'
    ]);
    yield put(fetchUserSuccess(user));
  } catch (error) {
    yield put(fetchUserError(error));
  }
}

export function* rootSaga() {
  yield takeEvery(types.FETCH_USER_START, fetchUser);
}

export default rootSaga;
